import { render, staticRenderFns } from "./ModalAguardandoNegociacaoParticular.vue?vue&type=template&id=dead95f2&scoped=true"
import script from "./ModalAguardandoNegociacaoParticular.vue?vue&type=script&lang=ts"
export * from "./ModalAguardandoNegociacaoParticular.vue?vue&type=script&lang=ts"
import style0 from "./ModalAguardandoNegociacaoParticular.vue?vue&type=style&index=0&id=dead95f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dead95f2",
  null
  
)

export default component.exports